import { prefix, suffix } from './variable-placeholders';
export var variablePattern = "".concat(prefix, "(.*?)").concat(suffix);
export var exactVariablePattern = /^{{(.*?)}}$/;
export var placeholderPattern = "[".concat(prefix).concat(suffix, "]");
export var trailingSlashesPattern = /^\/|\/$/g;
export var slugRegex = /{{slug}}/gi;
export var wildCardPattern = '([^/]+)';
//# sourceMappingURL=regex-patterns.js.map